import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { HOVER_MENU_DELAY } from '@/constants/hoverMenu';

export const HoverMenu = ({
  shouldOpen, customClass = '', forceClose, children, actionWhenOpen, actionWhenClose, closeWhenClickOutside = false,
  delayLeave = HOVER_MENU_DELAY.LEAVE, delayEnter = HOVER_MENU_DELAY.ENTER, setIsTimerTriggered
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const timerId = useRef();

  const clearMenuTimeout = () => {
    if (timerId.current) {
      clearTimeout(timerId.current);
      timerId.current = undefined;
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
  };

  const handleTimeout = (open) => () => {
    timerId.current = undefined;
    setIsOpen(open);

    setIsTimerTriggered?.(open);
  };

  useEffect(() => {
    clearMenuTimeout();

    timerId.current = setTimeout(
      handleTimeout(shouldOpen),
      shouldOpen ? delayEnter : delayLeave
    );

    return () => clearMenuTimeout();
  }, [shouldOpen]);

  useEffect(() => {
    if (isOpen) {
      clearMenuTimeout();
      setIsOpen(false);
    }
  }, [forceClose]);

  useEffect(() => (
    isOpen ? actionWhenOpen?.() : actionWhenClose?.()
  ), [isOpen]);

  useEffect(() => {
    if (closeWhenClickOutside) {
      window.addEventListener('click', handleTimeout(false));

      return () => {
        window.removeEventListener('click', handleTimeout(false));
      };
    }
  }, [closeWhenClickOutside]);

  return (
    <div data-test-id="hover-menu"
      data-rbf="hover-menu"
      className={[
        'tu-hover-menu',
        !isOpen && 'hover-menu-hide',
        customClass
      ].filter(Boolean).join(' ')} onClick={handleClick}>
      {children}
    </div>
  );
};

HoverMenu.propTypes = {
  shouldOpen: PropTypes.bool,
  customClass: PropTypes.string,
  forceClose: PropTypes.bool,
  actionWhenOpen: PropTypes.func,
  actionWhenClose: PropTypes.func,
  closeWhenClickOutside: PropTypes.bool,
  delayLeave: PropTypes.number,
  delayEnter: PropTypes.number,
  setIsTimerTriggered: PropTypes.func
};

export default React.memo(HoverMenu);
